import "./polyfills/legacy";
import { App } from "Core/App";

window._odepApp = new App(); // initialize App
